<template>
  <div class="input-container" :class="{ 'required-fail': requiredFail }">
    <v-radio-group
      :value="value"
      :input-value="value"
      @change="updateValue($event)"
      :column="radioInColumn"
      :hide-details="true"
      class="radio-input"
    >
      <v-radio
        v-for="option in radioOptions"
        :key="option.label"
        :label="option.label"
        :value="convertedValue(option.value)"
        :ripple="false"
        color="accent"
        :disabled="disabled"
      />
    </v-radio-group>
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";

export default {
  name: "InputTypeRadio",

  mixins: [inputTypeMixin],

  props: {
    radioInColumn: {
      type: Boolean,
      default: false
    },

    radioOptions: {
      type: Array,
      required: true
    }
  },

  computed: {
    valueType() {
      return typeof this.value;
    }
  },

  methods: {
    convertedValue(value) {
      let convertedValue = value;
      if (this.valueType === "number") {
        convertedValue = parseInt(value);
      } else if (this.valueType === "boolean") {
        convertedValue = value == "true";
      }
      return convertedValue;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/InputTypes/InputTypeRadio.vue